const GA4_ID = process.env.REACT_APP_GA4_ID;
const CLARITY_ID = process.env.REACT_APP_CLARITY_ID;
const GADS_ID = process.env.REACT_APP_GADS_ID; // es. AW-XXXXXXXXX — Google Ads
const GADS_LABEL = process.env.REACT_APP_GADS_CONVERSION_LABEL; // label conversione "generate_lead"
let loaded = false;

// Consent Mode v2: default negato PRIMA di qualsiasi caricamento
export function setConsentDefault() {
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function () {
      window.dataLayer.push(arguments);
    };
  window.gtag("consent", "default", {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    wait_for_update: 500,
  });
}

export function setConsentGranted() {
  if (window.gtag) {
    window.gtag("consent", "update", {
      analytics_storage: "granted",
      ad_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
    });
  }
}

export function trackVisit() {
  try {
    if (sessionStorage.getItem("dj-visit-logged")) return;
    sessionStorage.setItem("dj-visit-logged", "1");
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track-visit`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: window.location.pathname }),
    }).catch(() => {});
  } catch {
    /* sessionStorage non disponibile */
  }
}

export function loadAnalytics() {
  trackVisit();
  if (loaded) return;
  loaded = true;

  if (GA4_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(s);
    window.gtag("js", new Date());
    window.gtag("config", GA4_ID, { anonymize_ip: true });
    if (GADS_ID) window.gtag("config", GADS_ID);
  }

  if (CLARITY_ID) {
    window.clarity =
      window.clarity ||
      function () {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };
    const c = document.createElement("script");
    c.async = true;
    c.src = `https://www.clarity.ms/tag/${CLARITY_ID}`;
    document.head.appendChild(c);
  }
}

export function trackEvent(name, params = {}) {
  if (window.gtag) window.gtag("event", name, params);
  if (window.clarity) window.clarity("event", name);
}

// Conversione Google Ads: scatta solo se gli ID sono configurati via env
export function trackLeadConversion() {
  trackEvent("generate_lead", { page: window.location.pathname });
  if (window.gtag && GADS_ID && GADS_LABEL) {
    window.gtag("event", "conversion", { send_to: `${GADS_ID}/${GADS_LABEL}` });
  }
}
